export const workingHoursConstants = {
  GET_REQUEST: 'WORKING_HOURS_GET_REQUEST',
  GET_SUCCESS: 'WORKING_HOURS_GET_SUCCESS',
  GET_FAILURE: 'WORKING_HOURS_GET_FAILURE',
};
